import React, { FC } from 'react';
import * as S from './styled';
import iconMan from '../../../../img/icon_man.png';
import iconBurn from '../../../../img/icon_burn.png';
import iconScales from '../../../../img/icon_scales.png';
import { getWeeklyWeightLoss } from 'helpers';

interface Props {
	workouts?: string;
	calories?: number;
	currentWeight: number;
	goalWeight: number;
	weightUnit: string;
}

export const CalculationsBlock: FC<Props> = props => {
	const {
		workouts = '3-5',
		calories = 350,
		currentWeight = 85,
		goalWeight = 84,
		weightUnit = 'kg',
	} = props;

	const weeksLoseWeight = goalWeight === currentWeight ? 0 : getWeeklyWeightLoss(currentWeight);
	const plusMinus = goalWeight < currentWeight ? '-' : goalWeight > currentWeight ? '+' : '';

	return (
		<S.Container>
			<S.Item>
				<S.ItemLeft>
					<S.Icon src={iconMan} width={24} alt='man' />
					<S.Title>Workouts</S.Title>
				</S.ItemLeft>
				<S.Value>{workouts} / weekly</S.Value>
			</S.Item>
			<S.Item>
				<S.ItemLeft>
					<S.Icon src={iconBurn} width={24} alt='calories' />
					<S.Title>Calories burned</S.Title>
				</S.ItemLeft>
				<S.Value>{calories} kcal / daily</S.Value>
			</S.Item>
			<S.ItemLast>
				<S.ItemLeft>
					<S.Icon src={iconScales} width={24} alt='scales' />
					<S.Title>Weight</S.Title>
				</S.ItemLeft>
				<S.Value>
					{plusMinus}
					{weeksLoseWeight}&nbsp;
					{weightUnit} / weekly
				</S.Value>
			</S.ItemLast>
		</S.Container>
	);
};
